import { render, staticRenderFns } from "./SettingsSubscriptions.vue?vue&type=template&id=19ad90b3&scoped=true"
import script from "./SettingsSubscriptions.vue?vue&type=script&lang=js"
export * from "./SettingsSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./SettingsSubscriptions.vue?vue&type=style&index=0&id=19ad90b3&prod&scoped=true&lang=scss"
import style1 from "./SettingsSubscriptions.vue?vue&type=style&index=1&id=19ad90b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ad90b3",
  null
  
)

export default component.exports